<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "@/stores";
import IconToastAlert from "@/assets/icons/IconToastAlert.vue";
import IconToastSuccess from "@/assets/icons/IconToastSuccess.vue";
import IconCross from "@/assets/icons/IconCross.vue";

const store = useStore();
const toasts = computed(() => store.toasts);

const handleClose = (id: string) => {
  store.removeToast(id);
};
</script>

<template>
  <div class="wrapper">
    <TransitionGroup name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="toast"
        :class="`toast--${toast.type}`"
      >
        <div class="toast__status">
          <IconToastAlert v-if="toast.type === 'warning'" />
          <IconToastSuccess v-else />
        </div>
        <div class="toast__content">
          <span class="toast__title">
            {{ toast.title }}
          </span>
          <span
            v-if="toast.message"
            class="toast__message"
          >
            {{ toast.message }}
          </span>
        </div>
        <div
          class="toast__control"
          @click="handleClose(toast.id)"
        >
          <IconCross />
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped lang="scss">

.wrapper {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 12px;
  pointer-events: none;
}

.toast {
  display: flex;
  gap: 12px;
  border-radius: 8px;
  padding: 10px;
  background-color: var(--background-bg-white);
  box-shadow: 1px 2px 10px 0 var(--gray-gray50);
  pointer-events: all;
  min-width: 320px;
  max-width: 480px;

  &__content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
  }

  &__title {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: var(--text-text-black);
  }

  &__message {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: var(--gray-gray80);
  }

  &__control {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 24px;
    height: 24px;
    cursor: pointer;
    user-select: none;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
    }

    svg {
      color: var(--icon-icon-secondary);
      min-width: 14px;
      min-height: 14px;
    }
  }

  &__status {
    display: flex;
    align-items: flex-start;
    padding-top: 2px;
  }
}

// Анимация появления/исчезновения
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100px);
}

.toast-move {
  transition: transform 0.3s ease;
}
</style>